import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { AccessControlService } from '../services/access-control.service';
import { CompanyModuleKey } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ModuleGuard implements CanActivate, CanActivateChild {
  constructor(
    private accessControlService: AccessControlService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkModule(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkModule(route);
  }

  private checkModule(route: ActivatedRouteSnapshot): Observable<boolean> {
    const moduleKey = route.data?.['moduleKey'] as CompanyModuleKey | undefined;

    if (!moduleKey) {
      return of(true);
    }

    return this.accessControlService.config$.pipe(
      take(1),
      map(() => {
        const enabled = this.accessControlService.isModuleEnabled(moduleKey);
        if (!enabled) {
          this.router.navigate(['/dashboard']);
        }
        return enabled;
      }),
    );
  }
}
